import { Skeleton } from "@/shared/ui/skeleton"

export const NavigationPanelSkeleton: React.FC = () => {
  return (
    <nav className="block w-full border-t border-white/5 bg-gray-900/80 saturate-[1.8] backdrop-blur-[20px] md:hidden">
      <div className="mx-auto flex min-h-[68px] w-full items-center justify-between px-2 py-2">
        {Array.from({ length: 4 }).map((_, index) => (
          <div
            key={index}
            className="group relative flex min-w-0 flex-1 flex-col items-center justify-center pb-1 xs:pb-2">
            <div className="flex h-6 w-8 items-center justify-center rounded-lg xs:h-8 xs:w-10">
              <Skeleton className="h-4 w-4 xs:h-5 xs:w-5" />
            </div>
            <Skeleton className="mt-0.5 h-2 w-6 xs:mt-1 xs:h-2 xs:w-8" />
          </div>
        ))}
      </div>
    </nav>
  )
}
